function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import common from './common';
import shopMall from './shopMall';
import agreementModule from './agreementModule';
import commodityModule from './commodityModule';
import configureModule from './configureModule';
import contractModule from './contractModule';
import memberCenter from './memberCenter';
import operateModule from './operateModule';
import orderModule from './orderModule';
import paySettlementModule from './paySettlementModule';
import planModule from './planModule';
import storeModule from './storeModule';
import supplierModule from './supplierModule';
import pocOrderModule from './pocOrderModule';
import goodsZeroCategory from './goodsZeroCategory';
import accountCenter from './accountCenter';
import marketModule from '../marketUrl/index';
/**
 * 接口命名规范：中心名称_接口名称（保持原有大小写）
 **/

var DYC_URL = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  // 示例 命名规则：中心名称_最后一个接口名
  demo_getInfo: {
    // mock: true,
    control: 'demo/rest/xxx/getInfo'
  }
}, common), shopMall), agreementModule), commodityModule), configureModule), contractModule), memberCenter), operateModule), orderModule), paySettlementModule), planModule), storeModule), supplierModule), pocOrderModule), goodsZeroCategory), accountCenter), goodsZeroCategory), marketModule);

export default DYC_URL;